const classNames = require("classnames");

/**
 * LineLegend Component
 *
 * Displays a single-line legend row with optional top/bottom borders and a colored dot.
 * Useful for value breakdowns in charts or summary components.
 *
 * @param {Object} props - Component properties
 * @param {string} props.label - Text label to display on the left side
 * @param {string|number} props.value - Value to display on the right side (e.g., formatted euro string)
 * @param {boolean} [props.bottomBorder] - If true, applies bottom border with spacing
 * @param {boolean} [props.topBorder] - If true, applies top border with spacing
 * @param {string} [props.color] - Optional color for the circular bullet before the label
 * @returns {JSX.Element} Line legend display
 */
const LineLegend = ({ label, value, bottomBorder, topBorder, color }) => {
  const lineClass = classNames({
    "single-line": true,
    "border-grey-20": bottomBorder || topBorder,
    "border-b pb-3 mb-3": bottomBorder,
    "border-t pt-3 mt-3": topBorder,
  });

  return (
    <div className={lineClass}>
      <div className="single-line__label">
        {color && (
          <span className="color-dot" style={{ backgroundColor: color }} />
        )}
        <span>{label}</span>
      </div>
      <div className="single-line__value">{value}</div>
    </div>
  );
};

export default LineLegend;
